@if (modal_type === MT.Exchange) {
<div>
  <app-exchange-modal
      (close)="closeModal()"
      (submit)="submit()"
      [parent_sale_id]="parent_sale_id"
      [salesperson_full_name]="salesperson_full_name"
      [sales_number]="sales_number"
      [org_id]="org_id"
  ></app-exchange-modal>
</div>
}
@if (modal_type === MT.LinkedSale) {
<div>
  <app-linked-sale-modal
      (close)="closeModal()"
      (submit)="submit()"
      [parent_sale_id]="parent_sale_id"
      [salesperson_full_name]="salesperson_full_name"
      [sales_number]="sales_number"
      [org_id]="org_id"
      [processing_fee]="processing_fee"
      [transaction_fee]="transaction_fee"
      [service_fee_definition_method]="service_fee_definition_method"
      [shared_org_rate]="shared_org_rate"
      [shared_org_payment_plan_fee]="shared_org_payment_plan_fee"
      [shared_member_rate]="shared_member_rate"
      [shared_member_payment_plan_fee]="shared_member_payment_plan_fee"
  ></app-linked-sale-modal>
</div>
}
@if (modal_type === MT.BulkLinkedSale) {
<div>
  <app-bulk-linked-sale-modal
      (close)="closeModal()"
      (submit)="submit()"
      [parent_sales]="parent_sales"
      [org_id]="org_id"
      [processing_fee]="processing_fee"
      [transaction_fee]="transaction_fee"
      [service_fee_definition_method]="service_fee_definition_method"
      [shared_org_rate]="shared_org_rate"
      [shared_org_payment_plan_fee]="shared_org_payment_plan_fee"
      [shared_member_rate]="shared_member_rate"
      [shared_member_payment_plan_fee]="shared_member_payment_plan_fee"
  ></app-bulk-linked-sale-modal>
</div>
}